import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import WebIntlProvider from '../../ui/i18n/WebIntlProvider';
import ClipModal from './ClipModal';
import ClipNotificationModal from './ClipNotificationModal';
import ClipEmailModal from './ClipEmailModal';
import ClipEmailSuccessModal from './ClipEmailSuccessModal';
import ClipEmailNotificationModal from './ClipEmailNotificationModal';
import ClipClipboardModal from './ClipClipboardModal';
import ClipYetLogin from './ClipYetLogin';
import SmallNotificationModal from './SmallNotificationModal';

import TdLink from '../TdLink';
import {Message} from '@aperza/ui';

import RelayService from '../../service/RelayService';
import SaveClipMutation from '../../mutation/SaveClipMutation';
import { createFragmentContainer, graphql } from 'react-relay';

class Clip extends React.Component {

  static propTypes = {
    serviceId: PropTypes.number,
    itemPageShown: PropTypes.bool,
  };

  clipNotificationTimer = undefined;
  mailClipNotificationTimer = undefined;
  clipboardNotificationTimer = undefined;
  clipYetLoginTimer = undefined;

  constructor(props) {
    super(props);
    console.log('Clip constructor',props);

    let isClipSuccessModalChecked = localStorage.getItem("isClipSuccessModalChecked");
    let isMailClipSuccessModalChecked = localStorage.getItem("isMailClipSuccessModalChecked");
    let isClipboardClipSuccessModalChecked = localStorage.getItem("isClipboardClipSuccessModalChecked");
    isClipSuccessModalChecked = isClipSuccessModalChecked != null ? JSON.parse(isClipSuccessModalChecked) : false;
    isMailClipSuccessModalChecked = isMailClipSuccessModalChecked != null ? JSON.parse(isMailClipSuccessModalChecked) : false;
    isClipboardClipSuccessModalChecked = isClipboardClipSuccessModalChecked != null ? JSON.parse(isClipboardClipSuccessModalChecked) : false;

    localStorage.setItem("isClipSuccessModalChecked", isClipSuccessModalChecked);
    localStorage.setItem("isMailClipSuccessModalChecked", isMailClipSuccessModalChecked);
    localStorage.setItem("isClipboardClipSuccessModalChecked", isClipboardClipSuccessModalChecked);

    this.state = {
      isClipOpen: false,
      isMailOpen: false,
      isMailClipSuccessOpen: false,
      isMailClipNotificationOpen: false,
      isClipSuccessModalChecked: isClipSuccessModalChecked,
      isMailClipSuccessModalChecked: isMailClipSuccessModalChecked,
      isClipboardClipSuccessModalChecked: isClipboardClipSuccessModalChecked,
      isClipNotificationOpen: false,
      isClipboardOpen: false,
      isClipboardNotificationOpen: false,
      isClipYetLoginOpen: false,

      checkedModalMessage: null,
      checkedModalIcon: null
    }

    console.log("current This.state: ", this.state);
  }



  updateModalFlags() {
    let isClipSuccessModalChecked = localStorage.getItem("isClipSuccessModalChecked");
    let isMailClipSuccessModalChecked = localStorage.getItem("isMailClipSuccessModalChecked");
    let isClipboardClipSuccessModalChecked = localStorage.getItem("isClipboardClipSuccessModalChecked");
    isClipSuccessModalChecked = isClipSuccessModalChecked != null ? JSON.parse(isClipSuccessModalChecked) : false;
    isMailClipSuccessModalChecked = isMailClipSuccessModalChecked != null ? JSON.parse(isMailClipSuccessModalChecked) : false;
    isClipboardClipSuccessModalChecked = isClipboardClipSuccessModalChecked != null ? JSON.parse(isClipboardClipSuccessModalChecked) : false;
    this.setState({
      isClipSuccessModalChecked: isClipSuccessModalChecked,
      isMailClipSuccessModalChecked: isMailClipSuccessModalChecked,
      isClipboardClipSuccessModalChecked: isClipboardClipSuccessModalChecked,
    })
  }

  clickOpenClip() {
    let args = {
      menuType: this.props.menuType,
      serviceId: this.props.serviceId,
      contentType: this.props.contentType,
      contentDetailType: this.props.contentDetailType,
      contentKey: this.props.contentKey,
      contentTitle: this.props.contentTitle,
      contentImageUrl: this.props.contentImageUrl,
    };

    this.updateModalFlags();
    if( this.props.viewer.isLogin ){
      return SaveClipMutation.commit(
        RelayService.environment,
        args,
        (response, error) => {
          if (!this.state.isClipSuccessModalChecked) {
            this.setState({
              isClipOpen: true,
            })
          } else {
            this.setState({
              isClipNotificationOpen: true,
              checkedModalMessage: "clip.notification.catalog.clip",
              checkedModalIcon: "paperclip"
            })
            let _this = this;
            this.clipNotificationTimer = setTimeout(function(){
              _this.clickCloseClipNotification();
            },3000);
          }

        },
      );
     } else {
        this.setState({isClipYetLoginOpen: !this.state.isClipYetLoginOpen});
    }

  }

  clickOpenMailClip() {
    this.updateModalFlags();
    this.setState({
      isMailOpen: true,
    })
  }

  clickCloseClip() {
    console.log('clickCloseClip')
    this.setState({
      isClipOpen: false,
    })
  }

  clickCloseMailClip = () => {
    console.log('clickCloseMailClip')
    this.setState({
      isMailOpen: false,
    })
  }

  clickCloseClipNotification = () => {
    console.log('clickCloseClipNotification')
    clearTimeout(this.clipNotificationTimer);
    this.setState({
      isClipNotificationOpen: false,
    })
  };

  onClipEmailSuccess() {
    let isMailClipSuccessModalChecked = JSON.parse(localStorage.getItem("isMailClipSuccessModalChecked"));
    console.log('onClipEmailSuccess isMailClipSuccessModal', isMailClipSuccessModalChecked);
    this.setState({
      isMailOpen: false,
      isMailClipSuccessOpen: !isMailClipSuccessModalChecked,
      isMailClipNotificationOpen: isMailClipSuccessModalChecked,

      checkedModalMessage: "clip.notification.catalog.email",
      checkedModalIcon: "envelope"
    });
    if (isMailClipSuccessModalChecked) {
      let _this = this;
      this.mailClipNotificationTimer = setTimeout(() => {
        _this.clickCloseMailClipNotification();
      },3000);
    }
  }

  clickCloseClipEmailSuccess() {
    this.setState({
      isMailClipSuccessOpen: false,
    })
  }

  clickCloseMailClipNotification = () => {
    console.log('clickCloseMailClipNotification')
    clearTimeout(this.mailClipNotificationTimer);
    this.setState({
      isMailClipNotificationOpen: false,
    })
  };

  clickOpenClipboardClip() {
    let copyText = document.getElementById("myInput");
    copyText.select();
    document.execCommand("copy");

    this.updateModalFlags();

    if (!this.state.isClipboardClipSuccessModalChecked) {
      this.setState({
        isClipboardOpen: true,
      })
    } else {
      this.setState({
        isClipboardNotificationOpen: true,
        checkedModalMessage: "clip.notification.catalog.copy",
        checkedModalIcon: "copy"
      })
      let _this = this;
      this.clipboardNotificationTimer = setTimeout(function(){
        _this.clickCloseClipboardNotification();
      },3000);
    }

    // this.clipboardNotificationTimer = setTimeout(() => {
    //   _this.clickCloseClipboardNotification();
    // },3000);
  }

  clickCloseClipboardNotification = () => {
    console.log('clickCloseClipboardClip')
    clearTimeout(this.clipboardNotificationTimer);
    this.setState({
      isClipboardOpen: false,
      isClipboardNotificationOpen: false
    })
  };

  clickOpenClipYetLogin() {
    let _this = this;
    this.clipYetLoginTimer = setTimeout(() => {
      _this.clickCloseClipYetLogin();
    },3000);
  }

  clickCloseClipYetLogin = () => {
    console.log('clickCloseClipYetLogin')
    clearTimeout(this.clipYetLoginTimer);
    this.setState({
      isClipYetLoginOpen: false,
    })
  };

  render() {

    let td_clip_action      = "";
    let td_mail_clip_action = "";
    let td_clipboard_action = "";
    let clipText1 = "";
    let clipText2 = "";
    let clipEmailText1 = "";
    let clipEmailText2 = "";
    let clipUrlText1 = "";
    let clipUrlText2 = "";

    switch(this.props.serviceId){
        case 3:
          td_clip_action      = "aperza_clip_product";
          td_mail_clip_action = "aperza_clip_mail";
          td_clipboard_action = "aperza_clip_clipboard";
          clipText1 = itemPageShown === false ? "clip.search.clip.1" : "item.clip.search.clip.1";
          clipText2 = itemPageShown === false ? "clip.search.clip.2" : "item.clip.search.clip.2";
          clipEmailText1 = itemPageShown === false ? "clip.search.email.1" : "item.clip.search.email.1";
          clipEmailText2 = itemPageShown === false ? "clip.search.email.2" : "item.clip.search.email.2";
          clipUrlText1 = itemPageShown === false ? "clip.search.url.1" : "item.clip.search.url.1";
          clipUrlText2 = itemPageShown === false ? "clip.search.url.2" : "item.clip.search.url.2";
          break;
        case 5:
          // CATALOG CLIPPER
          td_clip_action      = "catalog_clip_catalog";
          td_mail_clip_action = "catalog_clip_mail";
          td_clipboard_action = "catalog_clip_clipboard";
          clipText1 = "clip.catalog.clip.1";
          clipText2 = "clip.catalog.clip.2";
          clipEmailText1 = "clip.catalog.email.1";
          clipEmailText2 = "clip.catalog.email.2";
          clipUrlText1 = "clip.catalog.url.1";
          clipUrlText2 = "clip.catalog.url.2";
          break;
        default:
          td_clip_action      = "mnews_clip";
          td_mail_clip_action = "mnews_clip_email";
          td_clipboard_action = "mnews_clip_clipboard";
          break;
    }

    // let td_clip_action= this.props.serviceId == 3 ? "aperza_clip_product" :
    //   this.props.serviceId == 5 ? "catalog_clip_catalog" : "mnews_clip";
    // let td_mail_clip_action = this.props.serviceId == 3 ? "aperza_clip_mail" :
    //   this.props.serviceId == 5 ? "catalog_clip_mail" : "mnews_clip_email";
    // let td_clipboard_action = this.props.serviceId == 3 ? "aperza_clip_clipboard" :
    //   this.props.serviceId == 5 ? "catalog_clip_clipboard" :  "mnews_clip_clipboard";

    let disabledLinks = false;

    let itemPageShown = this.props.itemPageShown;

    let wrapperClass = itemPageShown?'aw-clip-wrapper-item':'aw-clip-wrapper';
    let buttonClass = itemPageShown?'aw-clip-button-item':'aw-clip-button';

    let clipboardValue = this.props.contentTitle + "\r\n" + this.props.contentUrl;

    return (
      <WebIntlProvider>
        <div className={classnames('td_aperza_component_clip')}>
          <div className={classnames(wrapperClass)}>
            <div className={classnames(buttonClass)}>
              <TdLink action={td_clip_action} onClick={::this.clickOpenClip} disabled={disabledLinks}>
                <span className="aw-icon aw-icon-s aw-icon-link aw-icon-clip aw-inline aw-left"></span>
                <span className="aw-clip-button-link">
                  <Message messageId={clipText1}/><Message messageId={clipText2}/>
                </span>
              </TdLink>
            </div>
            <div className={classnames(buttonClass)}>
              <TdLink action={td_mail_clip_action} onClick={::this.clickOpenMailClip} disabled={disabledLinks}>
                <span className="aw-icon aw-icon-s aw-icon-link aw-icon-mail aw-inline aw-left"></span>
                <span className="aw-clip-button-link">
                  <Message messageId={clipEmailText1}/><Message messageId={clipEmailText2}/>
                </span>
              </TdLink>
            </div>
            <div className={classnames(buttonClass)}>
              <TdLink action={td_clipboard_action} onClick={::this.clickOpenClipboardClip} disabled={disabledLinks}>
                <span className="aw-icon aw-icon-s aw-icon-link aw-icon-copy aw-inline aw-left"></span>
                <span className="aw-clip-button-link">
                  <Message messageId={clipUrlText1}/><Message messageId={clipUrlText2}/>
                </span>
                <textarea type="text" value={clipboardValue} id="myInput" rows="5" style={{position: 'fixed', top: '-1000px'}} />
              </TdLink>
            </div>
          </div>
          <ClipModal open={this.state.isClipOpen} onClose={::this.clickCloseClip} {...this.props} />
          <ClipYetLogin open={this.state.isClipYetLoginOpen} onClose={this.clickCloseClipYetLogin} />

          <ClipEmailModal open={this.state.isMailOpen}  onClose={this.clickCloseMailClip} onSuccess={(::this.onClipEmailSuccess)} {...this.props} />
          <ClipEmailSuccessModal open={this.state.isMailClipSuccessOpen}  onClose={::this.clickCloseClipEmailSuccess} />

          <ClipClipboardModal open={this.state.isClipboardOpen} onClose={this.clickCloseClipboardNotification} />
          {/* <ClipNotificationModal open={this.state.isClipNotificationOpen} onClose={::this.clickCloseClipNotification} {...this.props} /> */}
          {/* <ClipEmailNotificationModal open={this.state.isMailClipNotificationOpen}  onClose={this.clickCloseMailClipNotification} /> */}
          {/* <ClipClipboardNotificationModal open={this.state.isClipboardNotificationOpen} onClose={this.clickCloseClipboardNotification} /> */}

          { /* THIS is for the after save checkbox modal */ }
          <SmallNotificationModal open={this.state.isClipNotificationOpen || this.state.isMailClipNotificationOpen || this.state.isClipboardNotificationOpen} messageId={this.state.checkedModalMessage} icon={this.state.checkedModalIcon} />
        </div>
      </WebIntlProvider>
    )
  }

}

export default createFragmentContainer(Clip, {
  viewer: graphql`
      fragment Clip_viewer on Viewer {
          id
          userId
          isInternalIp
          isLogin
          isBusiness
          isActiveBusinessCart
      }
  `}
);
